<template>
  <div @click.stop="handleClick">
    <CustomLink
      :text="category.name"
      :type="LINK_TYPE.NoStyle"
      :url="categoryLink"
      :should-push-url="true"
      :class="{ 'font-bold': isActive }"
    />
    <SideCategory
      v-for="subCategory in category.children"
      :key="subCategory.slug"
      :category="subCategory"
      class="pl-2"
    />
  </div>
</template>

<script lang="ts">

import type { PropType } from 'vue';
import type { Category } from '~~/types/commercetools';

import { LINK_TYPE } from '~~/types/components/Link/LinkType';
import { buildCategoryPageUrl } from '~~/helpers/category/buildCategoryPageUrl';
import { EVENT_SOURCE, FILTERS_INTERACTIONS } from '~~/constants/googleTagManager';

export default defineComponent({
  name: 'SideCategory',

  props: {
    category: {
      required: true,
      type: Object as PropType<Category>,
      validator: (category: unknown) =>
        typeof category === 'object' && !!category && 'name' in category && 'slug' in category,
    },
  },
  setup(props: {category: Category}) {

    const { activeCategories } = useCategories();
    const { categoryTree } = useCategoryTree();
    const { countryCode } = useLocalization();
    const { callClickFilterEvent } = useClickFiltersEvent();

    const isActive = computed(() =>
      props.category && activeCategories.value.some(
        (activeCategory) => activeCategory && activeCategory.slug === props.category.slug),
    );

    const categoryLink = computed(() => buildCategoryPageUrl({
      category: props.category.slug,
      countryCode: countryCode.value,
      categoryTree: categoryTree.value,
    }));

    const handleClick = () => {

      if (isActive.value) {

        return;

      }

      callClickFilterEvent({
        filterInteraction: FILTERS_INTERACTIONS.FILTER_SELECT,
        filterSection: EVENT_SOURCE.HIERARCHICAL_TREE,
        filterName: props.category.name,
        filterValue: props.category.name,
      });
    
    };

    return {
      isActive,
      LINK_TYPE,
      categoryLink,
      handleClick,
    };
  
  },
});

</script>
